import { useAuth } from "@/context/auth/AuthContext";
import React from "react";
import { Navigate } from "react-router-dom";

interface PrivateRouteProps {
  outlet: React.ReactNode;
}

export const PrivateRouteWithInstance = ({ outlet }: PrivateRouteProps) => {
  const { checkInstanceAndToken } = useAuth();

  if (!checkInstanceAndToken()) {
    return <Navigate to="/login" />;
  } else {
    return outlet;
  }
};
